import { Drawer, Modal } from "@mantine/core";
import { IconChevronLeft, IconDiscount2, IconMessage } from "@tabler/icons-react";
import { Link } from "react-router-dom";
import useIsSmall from "@/hooks/useIsSmall";
import classes from "./campaignChooser.module.css";

export type CampaignChoice = { title: string; count?: number; smsTo: string; discountTo: string };

// After tapping an opportunity: send a plain invitation or one with a discount code. The choice comes
// at the moment of acting, with what each does, instead of two competing buttons on every card.
export default function CampaignChooser({ choice, onClose }: { choice?: CampaignChoice; onClose: () => void }) {
  const isSmall = useIsSmall();
  const body = choice && (
    <div className={classes.body} dir="rtl">
      <p className={classes.context}>{choice.title}</p>
      <Link to={choice.smsTo} className={classes.option} onClick={onClose}>
        <span className={classes.icon}><IconMessage size={22} /></span>
        <span className={classes.text}>
          <strong>پیامک دعوت</strong>
          <span>متن آماده و سریع؛ کم‌هزینه‌ترین راه برای یادآوری.</span>
        </span>
        <IconChevronLeft size={18} className={classes.chevron} />
      </Link>
      <Link to={choice.discountTo} className={classes.option} data-tone="discount" onClick={onClose}>
        <span className={classes.icon}><IconDiscount2 size={22} /></span>
        <span className={classes.text}>
          <strong>پیامک با کد تخفیف</strong>
          <span>دلیل بیشتری برای برگشتن؛ هر نفر یک کد می‌گیرد و در سالن استفاده می‌کند.</span>
        </span>
        <IconChevronLeft size={18} className={classes.chevron} />
      </Link>
    </div>
  );
  return isSmall ? (
    <Drawer opened={!!choice} onClose={onClose} position="bottom" title="چطور دعوتشان کنیم؟" radius="lg"
      styles={{ content: { height: "auto", maxHeight: "85svh" }, title: { fontWeight: 700 } }}>
      {body}
    </Drawer>
  ) : (
    <Modal opened={!!choice} onClose={onClose} title="چطور دعوتشان کنیم؟" centered radius="lg" size="md" styles={{ title: { fontWeight: 700 } }}>
      {body}
    </Modal>
  );
}
